import { ActionIcon, Box, createStyles, Divider, Drawer, Group, Image, useMantineTheme } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { ROUTES } from '../config/RoutesName';
import { NavLink } from 'react-router-dom';
import { closeIcon, hamburger, headerLogo, logoicon, messageIcon, policyIcon, conatctUs, aboutUs } from '../assets';
import { Fragment } from 'react';

interface INavink {
  to: string;
  text: string;
  icon: string;
}

const navLinks: INavink[] = [
  {
    to: ROUTES.CONTACTUS,
    text: 'Contact Us',
    icon: conatctUs,
  },
  {
    to: ROUTES.FAQ,
    text: 'Frequently Asked Questions',
    icon: messageIcon,
  },
  {
    to: ROUTES.PRIVACYPOLICY,
    text: 'Policy',
    icon: policyIcon,
  },
  {
    to: ROUTES.TERMSCONDITIONS,
    text: 'Terms & Conditions',
    icon: policyIcon,
  },
  {
    to: ROUTES.ABOUT,
    text: 'About Us',
    icon: aboutUs,
  },
];

const useStyle = createStyles(() => ({
  dropdown: {
    borderRadius: 0,
    top: '75px !important',
    padding: '10px',
  },
  close: {
    color: '#FF8C22',
  },
  header: {
    padding: '30px 10px 20px 20px',
  },
  showButton: {
    display: 'none',
  },
}));

const NavMenu = ({ hideNavMenu }: any) => {
  const { classes } = useStyle();
  const [opened, { open, close }] = useDisclosure(false);
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);

  return (
    <>
      <ActionIcon>
        <Image
          width='auto'
          height='auto'
          className={hideNavMenu ? classes.showButton : ''}
          onClick={open}
          src={hamburger}
        />
      </ActionIcon>

      <Drawer
        opened={opened}
        onClose={close}
        withCloseButton={false}
        position='right'
        trapFocus={false}
        classNames={classes}>
        <Group position='right' p={'10px 0px 40px 0px'}>
          <Image
            onClick={close}
            pos={'absolute'}
            style={{ transform: 'translate(-50%)' }}
            left='50%'
            width='auto'
            height='auto'
            src={headerLogo}
          />
          <Image
            src={closeIcon}
            onClick={close}
            width='auto'
            height='auto'
            style={{
              cursor: 'pointer',
            }}
          />
        </Group>

        <Box p={20} pr={10}>
          {/* <NavLink to={`${ROUTES.ABOUT}`} style={{ textDecoration: 'none', color: 'black' }}>
            <Group
              fw={500}
              onClick={close}
              fz={mobile ? '12px' : '14px'}
              position='left'
              p={'10px 10px 15px 0px'}
              spacing='14px'>
              <ActionIcon>
                <Image width='20px' height='20px' src={logoicon} />
              </ActionIcon>
              About Clamor
            </Group>
          </NavLink> */}
          {/* <Divider my='sm' /> */}
          {navLinks?.map((_link, index) => (
            <Fragment key={`${_link?.to} - ${index}`}>
              <NavLink to={_link?.to} style={{ textDecoration: 'none', color: 'black' }}>
                <Group
                  fw={500}
                  onClick={close}
                  fz={mobile ? '12px' : '14px'}
                  position='left'
                  p={'15px 10px 15px 0px'}
                  spacing='14px'>
                  <ActionIcon>
                    <Image width='auto' height='auto' src={_link?.icon} />
                  </ActionIcon>
                  {_link?.text}
                </Group>
              </NavLink>
              <Divider my='sm' />
            </Fragment>
          ))}
        </Box>
      </Drawer>
    </>
  );
};

export default NavMenu;
